import styled, {css} from "styled-components";
import {themeColor, themeFontSize} from "ui/theme";
import {USDollar} from "../../../utils";
import moment from "moment";

export const DateCard = ({
                             date: {type, date, time, cost, online_type},
                             action,
                             hideBorder,
                             disablePadding,
                             hideTitle,
                             center = false,
                             boldCost = false,
                             shortDate = false,
                         }) => {
    const fullDate = moment(date).format("MMMM D, YYYY");
    const mobileDate = moment(date).format("MMM D");
    const cleanTime = moment(time, "hh:mm A").format("h:mmA");
    return (
        <CardContainer
            hideBorder={hideBorder}
            disablePadding={disablePadding}
            $hasAction={!!action}
            $hasType={!!type}
        >
            {type && (
                <TypeColumn center={center}>
                    {!hideTitle && <InfoLabel>TYPE</InfoLabel>}
                    <InfoValue>{online_type === "online" ? "Online" : type}</InfoValue>
                </TypeColumn>
            )}

            <InfoColumn center={center}>
                {!hideTitle && <InfoLabel>DATE</InfoLabel>}
                {shortDate ? (
                    <InfoValue>{mobileDate}</InfoValue>
                ) : (
                    <>
                        <DesktopOnly>{fullDate}</DesktopOnly>
                        <MobileOnly>{mobileDate}</MobileOnly>
                    </>
                )}
            </InfoColumn>

            <InfoColumn center={center}>
                {!hideTitle && <InfoLabel>TIME</InfoLabel>}
                <TimeValue>{cleanTime}</TimeValue>
            </InfoColumn>

            <InfoColumn center={center}>
                {!hideTitle && <InfoLabel $strong={boldCost}>COST</InfoLabel>}
                <InfoValue $strong={boldCost}>{USDollar.format(Number(cost.replace("$", "")))}</InfoValue>
            </InfoColumn>

            {action && <ActionContainer>{action}</ActionContainer>}
        </CardContainer>
    );
};

const CardContainer = styled.div`
    display: grid;
    width: 100%;
    grid-template-columns: repeat(${({$hasType, $hasAction}) => {
        let columns = 3;
        if ($hasType) columns += 1;
        if ($hasAction) columns += 1;
        return columns;
    }}, 1fr);
    align-items: center;

    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    ${({disablePadding}) => (disablePadding ? "" : "padding-bottom: 1rem;")}
    border-bottom: 2px solid rgb(237, 240, 255);

    @media (min-width: 768px) {
        gap: 0.8rem;
    }

    ${({hideBorder}) =>
            hideBorder &&
            css`
                border-bottom: none;
            `}
`;

const ActionContainer = styled.div`
    margin-left: auto;

    @media (min-width: 768px) {
        /* margin-left: 0; */
        margin: auto;
    }
`;

const InfoColumn = styled.div`
    display: flex;
    align-content: center;
    justify-content: center;
    flex-direction: column;
    align-items: ${({center}) => center ? "center" : null};
`;

const TypeColumn = styled.div`
    display: flex;
    flex-direction: column;
    align-items: ${({center}) => center ? "center" : null};
`;

const InfoLabel = styled.span`
    color: ${themeColor("txt")};
    opacity: ${({$strong}) => ($strong ? 0.85 : 0.5)};
    font-size: ${themeFontSize("extraSmall")};
    font-weight: 600;
    margin-bottom: 5px;
`;

const InfoValue = styled.span`
    color: ${themeColor("txt")};
    font-size: 13px;
    font-weight: ${({$strong}) => ($strong ? 700 : 400)};
    white-space: nowrap;
    text-transform: capitalize;
`;

const TimeValue = styled.span`
    color: ${themeColor("txt")};
    font-size: 13px;
    font-weight: 400;
    white-space: nowrap;
    text-transform: lowercase;
`;

const DesktopOnly = styled.span`
    display: none;
    color: ${themeColor("txt")};
    font-size: 13px;
    font-weight: 400;
    white-space: nowrap;
    text-transform: capitalize;

    @media (min-width: 768px) {
        display: inline;
    }
`;

const MobileOnly = styled.span`
    display: inline;
    color: ${themeColor("txt")};
    font-size: 13px;
    font-weight: 400;
    white-space: nowrap;
    text-transform: capitalize;

    @media (min-width: 768px) {
        display: none;
    }
`;